export const academicYearList: any = () => {
  const today: Date = new Date();
  const academicYear = (today.getMonth() >= 5) ? today.getFullYear() + "-" + (today.getFullYear() + 1) : (today.getFullYear() - 1) + "-" + today.getFullYear();
  return [{ name: 'Previous year - Current Year', value: academicYear }];
}
